import { useQuery } from "@tanstack/react-query";
import { fetchCustomerList } from "../api/crm";

/**
 * Single source of truth for the customer-list query key. Consumers
 * (`useCustomerList`, optimistic-update helpers in columns.tsx, etc.)
 * import this constant so cache reads/writes always agree — adding new
 * filter params later only needs one edit here.
 */
export const CUSTOMER_LIST_QUERY_KEY = ["crm", "customers"] as const;

export function useCustomerList() {
  return useQuery({
    queryKey: CUSTOMER_LIST_QUERY_KEY,
    queryFn: fetchCustomerList,
    staleTime: 10 * 60 * 1000, // 10 min
    gcTime: 30 * 60 * 1000,
  });
}
